<template>
  <splash/>
  <div class="container mt-4" dir="rtl">
    <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4" style="transform: translateX(-19vw)">

    <div class="card bg-white" style="    height: 69vw; padding: 2vw;">
      <div class="d-flex m-3 justify-content-between">
        <p class="fw-bold">
          ساختار سود و زیان
        </p>
        <div>
          <div class="d-flex changer">
            <router-link style="color: #000; font-size: 1vw; text-decoration: none" to="/Financial_management_and_productivity/ProfitAndLossStructure">
              جدول
            </router-link>
            <p>
              نمودار
            </p>
          </div>
        </div>
      </div>
     <center> <hr style="width: 90%;"></center>
      <Chart />


    </div>

    </div>
  </div>
</template>
<script  >
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import financial_information from "@/components/Financial_management_and_productivity/basic/financial_information.vue";
import Received_information from "@/components/Financial_management_and_productivity/basic/Received_information.vue";
import Outcome_information from "@/components/Financial_management_and_productivity/basic/Outcome_information.vue";
import Chart from "@/components/Financial_management_and_productivity/ProfitAndLossStructure/Chart.vue";

export  default {
  components: {Chart, Outcome_information, Received_information, Sidebar, Splash,financial_information}

}

</script>

<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 10vw;
  justify-content: space-evenly;
  &>p{
    width: 6vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(-.4vw);
    border-radius: 1vw;
  }
  &>a{
    margin-right: 1vw;
  }
  &>p{
  }  &>p {
   cursor: pointer;
  font-size: 1vw;
  }
}
p {
  font-size: 1vw;
}

</style>